var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-page-container"},[(!_vm.isEmbed)?[_vm._t("sidebar-left")]:_vm._e(),_c('div',{staticClass:"editor-page",class:[_vm.pageClass, { 'no-padding': _vm.noPadding}]},[_vm._t("default")],2),(!_vm.isEmbed)?[_vm._t("sidebar-right")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }